import module from 'nominas/finiquito/module.js'
import template from './template.html'

export class NominasFiniquitoAgregarComponent {
  idProyecto
  idColaborador
  idFiniquito
  onClose
  data
  catalogo = {
    esquemas: [],
  }
  esquema
  procesando = false

  constructor (NominasFiniquitoEscenarios, NominasCatalogos) {
    this.NominasFiniquitoEscenarios = NominasFiniquitoEscenarios
    this.NominasCatalogos = NominasCatalogos
  }

  $onInit () {
    this.NominasCatalogos.esquemas(this.idProyecto)
      .then((response) => {
        this.catalogo.esquemas = response.data
        this.data = {
          importe: null,
          fecha_baja: null,
          comentarios: '',
        }
      })
  }

  aceptar () {
    if (this.procesando) return

    this.procesando = true

    this.NominasFiniquitoEscenarios.post(this.idProyecto, this.idColaborador, this.idFiniquito, this.data)
      .then((response) => (this.onClose({$event: {data: response.data}})))
      .finally(() => (this.procesando = false))
  }

  cancelar () {
    this.onClose({$event: {}})
  }

  seleccionarEsquema () {
    this.data.id_esquema = this.esquema.id_esquema
    this.data.id_tipo_comision = this.esquema.id_tipo_comision
    this.data.id_metodo_calculo_comision = this.esquema.id_metodo_calculo_comision
    this.data.comision_porcentaje = this.esquema.comision_porcentaje
    this.data.comision_porcentaje_sa = this.esquema.comision_porcentaje_sa
    this.data.comision_porcentaje_op = this.esquema.comision_porcentaje_op
    this.data.iva_porcentaje = this.esquema.iva_porcentaje
  }
}

module.component('nominasFiniquitoEscenariosAgregar', {
  controller: NominasFiniquitoAgregarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    idFiniquito: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/escenarios/agregar/component.js